import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import Audiences from './components/Audiences';
import HowItWorks from './components/HowItWorks';
import Services from './components/Services';
import Pricing from './components/Pricing';
import Coverage from './components/Coverage';
import Reviews from './components/Reviews'; // Added Reviews import
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import TrackingPage from './pages/TrackingPage'; // Import the new TrackingPage
import PrivacyPolicy from './pages/PrivacyPolicy'; // Import the Privacy Policy page
import DriverPrivacyPolicy from './pages/DriverPrivacyPolicy'; // Import the Driver Privacy Policy page
import DriverTerms from './pages/DriverTerms'; // Import the Driver Terms page
import Contact from './pages/Contact'; // Import the Contact page

import LocationPicker from './pages/LocationPicker'; // Import the Location Picker page
import PublicOrderForm from './pages/PublicOrderForm'; // Import the Public Order Form
import ThankYouPage from './pages/ThankYouPage'; // Import the Thank You page
import BecomePartner from './pages/BecomePartner'; // Import the Become Partner page
import GetQuote from './pages/GetQuote'; // Import the Get Quote page
import QuickDelivery from './pages/QuickDelivery'; // Import the Quick Delivery page
import MesExpeditions from './pages/MesExpeditions'; // Import the "Mes expéditions" page (Lot 6)
import MerchantsPage from './pages/MerchantsPage'; // Import the Merchants (Marchands) page
import ComplaintPage from './pages/ComplaintPage';
import MobileAppLanding from './pages/MobileAppLanding';
import StoreSmartLinkPage from './pages/StoreSmartLinkPage';
import StoreRedirect from './pages/StoreRedirect';
import CataloguePage from './pages/CataloguePage';
import ModifyPricePage from './pages/ModifyPricePage';
import BookingPage from './pages/BookingPage';
import HomeV2 from './pages/HomeV2'; // MAQUETTE locale du nouvel accueil
import GestionRdvPage from './pages/GestionRdvPage';
import DriverAppDownload from './pages/DriverAppDownload';
import RouteDebug from './pages/RouteDebug';
import { initMetaPixel } from './utils/meta-pixel';
import { captureAttribution } from './utils/attribution';

function App() {
  // Tracking marketing (global) : initialise le pixel Meta sur toutes les pages
  // (pas seulement la page app) et capture les UTM dès l'arrivée depuis une pub.
  useEffect(() => {
    initMetaPixel();
    captureAttribution();
  }, []);

  // Scroll animation effect
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
            
            // If this is a service card, animate its icon with delay
            if (entry.target.classList.contains('service-card')) {
              const icon = entry.target.querySelector('.service-icon');
              if (icon) {
                setTimeout(() => {
                  icon.classList.add('visible');
                }, 300);
              }
            }
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll('.animate-on-scroll');
    elements.forEach((element) => observer.observe(element));

    // Cleanup
    return () => {
      elements.forEach((element) => observer.unobserve(element));
    };
  }, []);

  return (
    <Router>
      <Routes>
        {/* Fullscreen routes without navbar/footer */}
        <Route path="/confirm-address" element={<LocationPicker />} />
        <Route path="/f/:businessUid" element={<PublicOrderForm />} />
        <Route path="/c/:slug/p/:productId" element={<CataloguePage />} />
        <Route path="/c/:slug" element={<CataloguePage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/get" element={<StoreSmartLinkPage />} />
        <Route path="/go/:store" element={<StoreRedirect />} />
        <Route path="/driver-app" element={<DriverAppDownload />} />
        <Route path="/modifier-prix" element={<ModifyPricePage />} />
        <Route path="/accueil-v2" element={<HomeV2 />} />
        <Route path="/rendez-vous" element={<BookingPage />} />
        <Route path="/rendez-vous/gestion" element={<GestionRdvPage />} />
        <Route path="/rendez-vous/:slug" element={<BookingPage />} />
        <Route path="/debug/routing" element={<RouteDebug />} />

        {/* Main layout routes with navbar/footer */}
        <Route path="/*" element={
          <div className="font-sans bg-gray-50 text-gray-800">
            <Navbar />
            <Routes>
              <Route path="/" element={(
                <>
                  <HeroSection />
                  <Audiences />
                  <HowItWorks />
                  <Services />
                  <Pricing />
                  <Coverage />
                  {/* <Reviews /> */}
                  <FAQ />
                </>
              )} />

              <Route path="/tracking" element={<TrackingPage />} />
              <Route path="/ouigoo-app" element={<MobileAppLanding />} />
              <Route path="/pos" element={<MobileAppLanding />} />
              <Route path="/app" element={<MobileAppLanding />} />
              <Route path="/complaint" element={<ComplaintPage />} />
              <Route path="/become-partner" element={<BecomePartner />} />
              <Route path="/get-quote" element={<GetQuote />} />
              <Route path="/quick-delivery" element={<QuickDelivery />} />
              <Route path="/mes-expeditions" element={<MesExpeditions />} />
              <Route path="/marchands" element={<MerchantsPage />} />
              <Route path="/contact" element={<Contact />} />

              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/driver-privacy-policy" element={<DriverPrivacyPolicy />} />
              <Route path="/driver-terms-of-service" element={<DriverTerms />} />
            </Routes>
            <Footer />
          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App;
